import jwt_decode from 'jwt-decode'
/**
 * @module parser
 */

// tslint:disable:max-line-length
/**
 * @description only use it in frontend, since it use `window.atob`.
 * @param token jwt token.
 * 
 * ```ts
 * parseJwt('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c') === { sub: '1234567890', name: 'John Doe', iat: 1516239022 }
 * ```
 */

export function parseJwt<R = ReturnType<typeof JSON.parse>>(token: string): R {
	return jwt_decode(token)
}
